import morph from "../helpers/morph";
import { initializeTooltips } from "../global/tooltip/tooltip";

window.cartContentRequestId = 1;

class CartContent extends HTMLElement {
  constructor() {
    super();

    this._updateQty = ({ key, quantity }) => {
      window.changeCart(
        { id: key, quantity },
        {
          onError: (response) => {
            const message =
              response?.message || response?.description || window.localeStrings?.cart?.updateError;

            if (message && typeof window.showToast === "function") {
              window.showToast(message);
            }

            this._refreshCart();
          },
          data: { requestId: ++window.cartContentRequestId },
        },
      );
    };

    this.addEventListener("click", (e) => {
      const removeButton = e.target.closest("[data-remove]");
      const upsellButton = e.target.closest("[data-add-upsell-to-cart]");

      if (removeButton) {
        const item = e.target.closest("[data-item-key]");

        if (!item) return;

        this._updateQty({
          key: item.dataset.itemKey,
          quantity: 0,
        });

        return;
      }

      if (upsellButton) {
        window.addToCart(
          {
            id: upsellButton.dataset.variantId,
            quantity: 1,
          },
          {
            data: {
              requestId: ++window.cartContentRequestId,
            },
          },
        );
      }
    });

    document.addEventListener("updateCart", (e) => {
      const requestId = e.detail.data?.requestId;

      if (requestId === window.cartContentRequestId || !requestId) {
        const markup = e.detail.cart.sections?.[this.sectionId];

        if (markup) {
          this._updateCart(markup);
        }
      }
    });

    this.addEventListener("change", (e) => {
      const item = e.target.closest("[data-item-key]");

      if (!item) return;

      this._updateQty({
        key: item.dataset.itemKey,
        quantity: parseInt(e.target.value, 10),
      });
    });
  }

  _refreshCart() {
    window
      .fetchPageData({
        path: "/cart",
        options: {
          sectionId: this.sectionId,
        },
      })
      .then((markup) => {
        this._updateCart(markup);
      });
  }

  _updateCart(markup) {
    const html = new DOMParser().parseFromString(markup, "text/html");
    const sourceContent = html.querySelector(`cart-content[cart-section-id="${this.sectionId}"]`);

    if (!sourceContent) return;

    const currentIsEmpty = this.dataset.cartEmpty === "true";
    const nextIsEmpty = sourceContent.dataset.cartEmpty === "true";

    if (currentIsEmpty !== nextIsEmpty) {
      this.replaceWith(sourceContent);

      // Tooltips only initialize on page load, so the fresh markup (e.g. the
      // wedding-details "Why are we asking?" tooltip after the first add to
      // an empty cart) would otherwise never respond to taps.
      initializeTooltips(sourceContent);
      return;
    }

    morph(this, sourceContent);

    // morph can insert tooltip markup or swap its trigger/content nodes, leaving
    // an existing instance bound to detached elements.
    initializeTooltips(this);
  }

  get sectionId() {
    return this.getAttribute("cart-section-id");
  }
}

if (!customElements.get("cart-content")) {
  customElements.define("cart-content", CartContent);
}
